import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AlertsService } from './api/alerts.service';
import { AnswersService } from './api/answers.service';
import { AttendanceRegistersService } from './api/attendanceRegisters.service';
import { AuthService } from './api/auth.service';
import { CertificatesService } from './api/certificates.service';
import { CertificationBonusesService } from './api/certificationBonuses.service';
import { CertificationCoursesService } from './api/certificationCourses.service';
import { CertificationFamiliesService } from './api/certificationFamilies.service';
import { CertificationGroupsService } from './api/certificationGroups.service';
import { CertificationsService } from './api/certifications.service';
import { ConsoleManagerService } from './api/consoleManager.service';
import { CoursePathsService } from './api/coursePaths.service';
import { CourseSummaryDocumentsService } from './api/courseSummaryDocuments.service';
import { CoursesService } from './api/courses.service';
import { CurriculaService } from './api/curricula.service';
import { CurriculumOptionsService } from './api/curriculumOptions.service';
import { DaysService } from './api/days.service';
import { DevicesService } from './api/devices.service';
import { EditionsService } from './api/editions.service';
import { EnrollmentsService } from './api/enrollments.service';
import { ExemptionsService } from './api/exemptions.service';
import { ExpertisesService } from './api/expertises.service';
import { ExternalCertificationTestsService } from './api/externalCertificationTests.service';
import { ExternalCertificationTimesService } from './api/externalCertificationTimes.service';
import { FilesService } from './api/files.service';
import { FinalReviewsService } from './api/finalReviews.service';
import { HelpsService } from './api/helps.service';
import { LocationTypesService } from './api/locationTypes.service';
import { LocationsService } from './api/locations.service';
import { MatricesService } from './api/matrices.service';
import { MediaLibraryObjectsService } from './api/mediaLibraryObjects.service';
import { MulticoursesService } from './api/multicourses.service';
import { NetworksService } from './api/networks.service';
import { NewsService } from './api/news.service';
import { NotesService } from './api/notes.service';
import { OfficesService } from './api/offices.service';
import { OnlineCoursesService } from './api/onlineCourses.service';
import { PathsService } from './api/paths.service';
import { PositionsService } from './api/positions.service';
import { ProductSheetsService } from './api/productSheets.service';
import { QuestionCategoriesService } from './api/questionCategories.service';
import { QuestionsService } from './api/questions.service';
import { QuizResultsService } from './api/quizResults.service';
import { ReportsService } from './api/reports.service';
import { RoomsService } from './api/rooms.service';
import { SatisfactionQuizzesService } from './api/satisfactionQuizzes.service';
import { SegmentsService } from './api/segments.service';
import { TargetsService } from './api/targets.service';
import { TeachersService } from './api/teachers.service';
import { TeachingSocietiesService } from './api/teachingSocieties.service';
import { ThirdPartyCompaniesService } from './api/thirdPartyCompanies.service';
import { UploadsService } from './api/uploads.service';
import { UsersService } from './api/users.service';
import { UtilsService } from './api/utils.service';
import { WebsocketsService } from './api/websockets.service';
import { WsService } from './api/ws.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
